$(document).ready(function () {
  $('#headerDropdown').click(function () {
    $('.dropdown-menu').slideToggle()
  });
});
